import { Injectable } from '@angular/core';
import { User } from 'src/app/_models/user';
import { MenuItem } from 'src/app/_models/menu.item';
import { navigation } from 'src/app/_nav';
import { AuthenticationService } from './authentication.service';

@Injectable({
    providedIn: 'root'
})
export class MenuClaimService {

    constructor(private authService: AuthenticationService) {

    }

    mountMenuByClaims(): MenuItem[] {
        let user = this.authService.currentUserValue;

        let menu: MenuItem[] = navigation;
        let menuFilter: MenuItem[] = [];

        let userClaims = Object.keys(user.data.user.claims.reduce((a, { type, value }) => Object.assign(a, { [type + "_" + value]: undefined }), {}));

        menu.forEach(menu => {

            if (menu.claim != undefined) {

                let test = menu.claim.nome + "_" + menu.claim.valor

                if (userClaims.indexOf(test) != -1) {
                    menuFilter.push(menu);
                }
            }
            else
                menuFilter.push(menu);

        });

        return menuFilter
    }
}
